__turbopack_context__.v({
  "progress": "styles-module-scss-module__IvV1XG__progress",
  "progressColor": "styles-module-scss-module__IvV1XG__progressColor",
  "root": "styles-module-scss-module__IvV1XG__root",
});
